import { TableSortLabel } from "@material-ui/core";

const SortingBoldTableCell = ({ children, active, setActive, setDirection, direction, props, name }) => {
    const onClick = () => {
        if (active === name) {
            if (direction === "asc") {
                setDirection("desc");
            } else {
                setDirection("asc");
            }
        } else {
            setActive(name);
        }
        setActive(name);
    };

    return (
        <th scope="col" className="px-4 py-2 text-left font-semibold">
            <TableSortLabel {...props} active={active === name} direction={direction} onClick={onClick}>
                {children}
            </TableSortLabel>
        </th>
    );
};

export default SortingBoldTableCell;